import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/login')({
  beforeLoad: () => {
    throw redirect({ to: '/connexion', replace: true })
  },
})
